/**
 * Client-side defense for free-text form fields (remarks, reasons).
 * SQL injection is still prevented on the API with parameterized queries;
 * this only strips characters that should not appear in remarks.
 */
const UNSAFE_FORM_TEXT_SOURCE = "[<>'\"\\\\;`|&$={}[\\]\\x00]|--|/\\*|\\*/";

function unsafeFormTextPattern() {
  return new RegExp(UNSAFE_FORM_TEXT_SOURCE, 'g');
}

export const SAFE_FORM_TEXT_MESSAGE = 'Special characters are not allowed.';

export function sanitizeFormTextInput(value = '') {
  return String(value ?? '').replace(unsafeFormTextPattern(), '');
}

export function isSafeFormText(value = '') {
  return !unsafeFormTextPattern().test(String(value ?? ''));
}

export function yupSafeFormText(yupString) {
  return yupString.test(
    'safe-form-text',
    SAFE_FORM_TEXT_MESSAGE,
    (value) => value == null || value === '' || isSafeFormText(value),
  );
}
